module.exports = __webpack_public_path__ + "static/media/footer-earth-2.0af209d9.svg";